import { IHttpService, IQService } from "angular";
import { IdLabel } from "../model/properties.model";

export class TimeUnitService {
	static $inject = ['$http', '$q'];
	constructor(
		private $http: IHttpService,
		private $q: IQService
	) { }

	getWeekdays() {
		return this.$http.get<IdLabel[]>('api/weekdays', { cache: true });
	}

	getWeekdaysAndMonths() {
		return this.$q.all({
			weekdays: this.getWeekdays(),
			months: this.$http.get<IdLabel[]>('api/months', { cache: true })
		});
	}
}

angular.module('logbook').service('timeUnitService', TimeUnitService);